module.exports = __webpack_public_path__ + "img/home_menu_profile120.fce74604.png";